const MetadataActionTypes = {
	UPDATE_WINDOW_INNER_HEIGHT: "UPDATE_WINDOW_INNER_HEIGHT",
	TURN_ON_RESIZE_LISTENER: "TURN_ON_RESIZE_LISTENER",
	TURN_OFF_RESIZE_LISTENER: "TURN_OFF_RESIZE_LISTENER",
	UPDATE_METADATA: "UPDATE_METADATA",
};

export default MetadataActionTypes;
